import { FileExtension } from '~/file-extension';
import { WrTooltip } from '../../../styled-components/common/wr-tooltip';
import FileUploaderWithProgress from '../../common/file_uploader_with_progress';

function ImageSettingEditor({
  currentImage,
  name,
  description,
  currentImageFileName,
  handleRemoveClick,
  additionalOptions,
  prepareUploadUrl,
  uploadCompletedUrl,
  uploadCompleted,
  tips,
}) {
  if (currentImage) {
    return (
      <div className="form-field">
        <div className="form-label flex">
          {name}
          {description ? (
            <WrTooltip content={description} direction="right">
              <img
                src="/images/info_icon.svg"
                className="mlm"
                height="12px"
                width="12px"
                style={{ position: 'relative', top: '1px' }}
              />
            </WrTooltip>
          ) : null}
        </div>
        <div className="form-input-text form-input-file">
          <a className="form-input-file-name" href={currentImage}>
            {currentImageFileName}
          </a>
          <img className="reset-field-button" src="/images/cross_icon_blue.svg" onClick={handleRemoveClick} />
        </div>
        {additionalOptions}
      </div>
    );
  }
  return (
    <div className="form-field">
      <div className="form-label flex">
        {name}
        {description ? (
          <WrTooltip content={description} direction="right">
            <img
              src="/images/info_icon.svg"
              className="mlm"
              height="12px"
              width="12px"
              style={{ position: 'relative', top: '1px' }}
            />
          </WrTooltip>
        ) : null}
      </div>
      <FileUploaderWithProgress
        title={`Upload ${name}`}
        prepareUploadUrl={prepareUploadUrl}
        uploadCompletedUrl={uploadCompletedUrl}
        showImgLink
        uploadCompleted={uploadCompleted}
        filter={function (filename) {
          return FileExtension(filename).isImage();
        }}
        failedFilterMessage="You seem to have selected a file that is not an image. Please select an image to upload."
      />
      <div className="form-field-subtext">{tips}</div>
    </div>
  );
}

export default ImageSettingEditor;
